module.exports = __webpack_public_path__ + "img/uso_quebra_ventos_3.40127fdf.webp";